import { css } from '@emotion/react';
import { ScopedLocationFilterMenu } from '@frontend/location-filter-menu';
import { theme } from '@frontend/theme';
import { HandledBySelectorFilter } from '../filter-selectors/handled-by-selector-filter';
import { TimePeriodPopoverSelector } from '../filter-selectors/time-period-select-popover';
import { DEFAULT_NO_TIME_PERIOD, PeriodFilter } from '../filter-selectors/time-period-selector';

type ToolbarChipFilter = {
  locationIds: string[];
  startDate: string;
  endDate: string;
  aiReceptionistHandled?: boolean;
  handledByUserIds?: string[];
  allOfficeUsers?: boolean;
};
interface FilterProps {
  defaultTimePeriod?: PeriodFilter;
  filters: ToolbarChipFilter;
  onChange: (args: ToolbarChipFilter) => void;
  showHandledByFilter?: boolean;
  trackingBaseId?: string;
}

export const ToolbarChipFilter = ({
  defaultTimePeriod,
  filters,
  onChange,
  showHandledByFilter,
  trackingBaseId = 'all-calls-toolbar',
}: FilterProps) => {
  const handleChange = (filters: ToolbarChipFilter) => {
    onChange(filters);
  };

  return (
    <div css={styles.mainWrapper}>
      <ScopedLocationFilterMenu
        selectedOptions={filters.locationIds}
        trackingIdBase={trackingBaseId}
        onChange={(locations) => {
          handleChange({ ...filters, locationIds: locations });
        }}
        showClearAll={false}
      />

      <TimePeriodPopoverSelector
        defaultPeriod={defaultTimePeriod ?? DEFAULT_NO_TIME_PERIOD}
        onChange={({ endDate, startDate }) => {
          onChange({ ...filters, startDate, endDate });
        }}
        startDate={filters.startDate}
        endDate={filters.endDate}
        trackingId={`${trackingBaseId}-time-selector-chip-filter`}
      />
      {showHandledByFilter && (
        <HandledBySelectorFilter
          filters={filters}
          setFilters={(f) => onChange({ ...filters, ...f })}
          fieldContainerCss={styles.handledByFieldContainer}
          width={220}
          variant={'chip'}
          trackingId={`${trackingBaseId}-handled-by-chip-filter`}
        />
      )}
    </div>
  );
};

const styles = {
  mainWrapper: css`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing(2)};
    position: relative;
    flex-grow: 1;
  `,
  handledByFieldContainer: css`
    > div {
      border-color: ${theme.colors.neutral50};

      label {
        color: ${theme.colors.neutral90};
      }
    }
  `,
};
